module.exports = __webpack_public_path__ + "img/popup_bg_s6.8c67bc5c.png";